// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2642":"377c753e7bcaf21e","6145":"6cbd35f2a42d4591"}[chunkId] + ".js";
};